<template>
    <div class="main-wrapper">

		<div class="login-page">
			<div class="login-body container">
				<div class="loginbox">
					<div class="login-right-wrap">
						<div class="account-header">
							<div class="account-logo text-center mb-4">
								<router-link to="/">
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span 
                      class="font-weight-600 text-slate-300" 
                      :style="logoPrefixStyle"
                    >
                      {{ branding.logo.prefix }}
                    </span>
                    <span 
                      class="font-weight-bold text-slate-500"
                      :style="logoSuffixStyle"
                    >
                      {{ branding.logo.suffix }}
                    </span>
                  </a>
                </router-link>
							</div>
						</div>
						<div class="login-header text-center">
              <div class="mt-4">
                <div class="alert alert-info">
                  <p>Set up your your account details below</p>
                </div>
              </div>
              </div>
						</div>

          <form action="">
            <div class="form-group mb-4">
              <input
                type="password"
                class="form-control"
                id="password"
                required
                v-model="password"
                name="password"
                placeholder="Enter your password"
                autocomplete="new-password"
              />
            </div>
            <div class="form-group mb-4">
              <input
                type="password"
                class="form-control"
                id="confirmPassword"
                required
                v-model="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm your password"
                autocomplete="new-password"
              />
            </div>
            <div class="text-center">
              <button class="btn btn-primary btn-block account-btn" type="button" @click="acceptInvite">Confirm</button>
              <button class="btn btn-primary btn-block account-btn" type="button" @click="login()" style="background-color: white; color: black">Cancel</button>
            </div>
          </form>

            <div class="text-center dont-have">
              <div>
                <small id="terms-footnote" class="footnote">
                  By continuing, you confirm you have read and agree to the <a href="https://salesdue.com/privacy">privacy policy</a> and  <a href="https://salesdue.com">terms and conditions</a> that govern your usage of FastaText services.
                </small>
              </div>
            </div>
          </div>
				</div>
			</div>
		</div>
</template>

<script>
import AuthServiceApi from "../../service/AuthServiceApi";
import authServiceApi from "../../service/AuthServiceApi";
import { getBrandingByDomain } from "@/config/domainBranding";
import { handleError } from "../../utils/notification.utils";

export default {
  name: "register-user",
  data() {
    return {
      invitation: undefined,
      invitationId: undefined,
      token: undefined,
      firstName: undefined,
      lastName: undefined,
      password: undefined,
      branding: getBrandingByDomain(location.host)
    };
  },
  methods: {
    login(){
      this.$router.push('/login');
    },
    retrieveUser() {
      authServiceApi.userExists(this.invitation.email, '123456')
        .then(response => {
          const result = response.data.data;
          if (result === true){
            this.acceptInvite();
          }
        })
        .catch(e => {
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409){
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        });
    },
    retrieveInvitation() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      authServiceApi.findInviteById(this.invitationId,  '123456')
        .then(response => {
          if (response.data.code === 'SUCCESS'){
            this.invitation = response.data.data
            if (this.invitation.status === 'ACCEPTED'){
              this.$router.push("/login");
              this.fireNotification("error", 'Error!', 'Invitation has already been accepted!');
            } else if (this.invitation.status === 'EXPIRED'){
              this.$router.push("/login");
              this.fireNotification("error", 'Error!', 'Invitation has expired!');
            } else if (this.invitation.status === 'REJECTED'){
              this.$router.push("/login");
              this.fireNotification("error", 'Error!', 'Invitation has already been rejected!');
            }
            //this.retrieveUser(this.invitation.id)
          } else {
            this.fireNotification("error", 'Error!', response.data.description);
            this.$router.push("/login");
          }
        })
        .catch(e => {
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409){
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          loader.hide()
        })
    },
    acceptInvite() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      let data = {
        password: this.password,
        confirmPassword: this.confirmPassword,
        domain: location.host,
      }
      AuthServiceApi.acceptInvite(this.invitationId, data)
        .then(response => {
          if (response.data.code === 'SUCCESS'){
            this.invitation = response.data.data;
            this.resetMessage();
            Swal.fire({
              icon: 'success',
              title: 'Confirmed',
              text: 'You will now be redirected to login page',
              confirmButtonText: 'Continue',
              footer: '<a href="">Need help?</a>'
            }).then(()=>{
              this.$router.push("/login");
            })
          } else if (response.data.code === 'MEMBERSHIP_ALREADY_EXISTS'){
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Member already exists',
              footer: '<a href="">Need help?</a>'
            }).then(()=>{
              this.$router.push("/login");
            })
          }
          else {
            this.fireNotification("error", 'Error!', response.data.description);
          }
        })
        .catch(e => {
          handleError(e);
        })
        .finally(() => {
          loader.hide()
      })
    },
    rejectInvite() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      AuthServiceApi.rejectInvite(this.invitationId, {})
        .then(response => {
          if (response.data.code === 'SUCCESS'){
            this.invitation = response.data.data;
            this.resetMessage();
            Swal.fire({
              icon: 'error',
              title: 'Rejected',
              text: 'You will now be redirected to login page',
              confirmButtonText: 'Continue',
              footer: '<a href="">Need help?</a>'
            }).then(()=>{
              this.$router.push("/login");
            })
          } else if (response.data.code === 'MEMBERSHIP_ALREADY_EXISTS'){
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Member already exists',
              footer: '<a href="">Need help?</a>'
            }).then(()=>{
              this.$router.push("/login");
            })
          }
          else {
            this.fireNotification("error", 'Error!', response.data.description);
            this.$router.push("/login");
          }
        })
        .catch(e => {
          console.log(e);
          if (e.response && e.response.status){
            if (e.response.status === 400 && e.response.data.code === 'MEMBERSHIP_ALREADY_EXISTS'){
              Swal.fire({
                icon: 'warning',
                title: 'Error',
                text: 'Member already exists',
                footer: '<a href="">Need help?</a>'
              }).then(()=>{
                this.$router.push("/login");
              })
              return;
            }
            if (e.response.status === 400 || e.response.status === 401 || e.response.status === 403 || e.response.status === 409){
              this.fireNotification("warning", 'Error!!', e.response.data.narrative)
              this.$router.push("/login");
              return
            }
          }
          this.fireNotification("error", 'Error!', "Something unexpected happened!")
        })
        .finally(() => {
          loader.hide()
        })
    },
    resetMessage(){
      this.token = null
    },
    fireNotification(icon, title, message) {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
        footer: '<a href="">Need help?</a>'
      })
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    logoSuffixStyle() {
      return {
        color: this.branding.logo.suffixColor || '#ffffff',
        fontWeight: 'bold',
        backgroundColor: this.branding.logo.suffixBackgroundColor || this.branding.primaryColor,
        padding: '6px',
        borderRadius: '5px'
      }
    },
    logoPrefixStyle() {
      return {
        color: this.branding.logo.prefixColor || this.branding.secondaryColor
      }
    }
  },
  async mounted() {
    if (this.currentUser) {
      await this.$store.dispatch('auth/logout')
      localStorage.clear()
    }
    this.invitationId = this.$route.params.id
    this.retrieveInvitation();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/invitations/AcceptInvite.vue